import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ab8a12c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-4 mx-2 mb-2 text-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-3 font-weight-bold" }, [
  /*#__PURE__*/_createTextVNode("\n          本人確認のため、"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("生年月日を教えてください\n        ")
], -1))
const _hoisted_3 = { class: "mt-4 mx-2 mb-2 text-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-3 font-weight-bold" }, [
  /*#__PURE__*/_createTextVNode("\n        生年月日が間違っています。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("復帰を希望される場合は、"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("運営事務局へお問い合わせください。\n      ")
], -1))

import { computed, ref, watch } from "vue";
import AppButton from "@/components/atoms/button/AppButton.vue";
import AppButtonOutline from "@/components/atoms/button/AppButtonOutline.vue";
import FormSelectGroup from "@/components/molecules/form/FormSelectGroup.vue";
import ExternalLink from "@/const/externalLink";
import {
  endOfMonth,
  formatFromUnixTimestamp,
  getYear,
  now,
  parseISO
} from "@/utils/date";
import CustomValidationObserver from "@/plugins/CustomValidationObserver.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmBirthDateModal',
  props: {
  isShownInputModal: {
    type: Boolean,
    required: true
  },
  isShownIncorrectModal: {
    type: Boolean,
    default: false
  }
},
  emits: ["close", "ok"],
  setup(__props, { emit: emits }) {



const birthDateYear = ref<number>(1990);
const birthDateMonth = ref<number>(12);
const birthDateDay = ref<number | null>(31);
const vObserver = ref<CustomValidationObserver | null>(null);
const birthDateDayElement = ref<FormSelectGroup | null>(null);

const formValues = computed(() => ({
  birthDateYear: birthDateYear.value,
  birthDateMonth: birthDateMonth.value,
  birthDateDay: birthDateDay.value
}));
const birthDateYearOptions = computed(() => {
  const currentYear = getYear(now());
  const yearOptions = Array.from({ length: 100 }, (_, i) => {
    const year = currentYear - i;
    return { value: year, text: `${year}年` };
  }).reverse();
  return yearOptions;
});
const birthDateMonthOptions = computed(() => {
  const monthOptions = Array.from({ length: 12 }, (_, i) => {
    const month = i + 1;
    return { value: month, text: `${month}月` };
  });
  return monthOptions;
});
const birthDateDayOptions = computed(() => {
  // 月末日を取得
  const lastDayOfMonth = Number(
    formatFromUnixTimestamp(
      endOfMonth(
        parseISO(
          `${birthDateYear.value}-${birthDateMonth.value
            .toString()
            .padStart(2, "0")}-01`
        )
      ),
      "d"
    )
  );
  const dayOptions = Array.from({ length: lastDayOfMonth }, (_, i) => {
    const day = i + 1;
    return { value: day, text: `${day}日` };
  });
  return dayOptions;
});
const birthDate = computed(() => {
  if (birthDateDay.value === null) {
    return null;
  }
  return `${birthDateYear.value}-${birthDateMonth.value
    .toString()
    .padStart(2, "0")}-${birthDateDay.value.toString().padStart(2, "0")}`;
});

watch(
  () => [birthDateYear.value, birthDateMonth.value],
  () => {
    if (!birthDateDay.value) return;
    // 選択した月に存在しない日付が入力されていた場合、未入力に戻す
    if (!birthDateDayOptions.value.some(o => o.value === birthDateDay.value)) {
      birthDateDay.value = null;
      // NOTE: 誕生日のバリデーションを走らせるために handleChange を呼ぶ
      birthDateDayElement.value!.validationState.handleChange(null, true);
    }
  }
);



function onSubmit() {
  emits("ok", birthDate.value);
}

return (_ctx: any,_cache: any) => {
  const _component_ValidationProvider = _resolveComponent("ValidationProvider")!
  const _component_BCol = _resolveComponent("BCol")!
  const _component_BRow = _resolveComponent("BRow")!
  const _component_BModal = _resolveComponent("BModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomValidationObserver, {
      "initial-values": formValues.value,
      ref_key: "vObserver",
      ref: vObserver
    }, {
      default: _withCtx(({ handleSubmit }) => [
        _createVNode(_component_BModal, {
          visible: __props.isShownInputModal,
          centered: "",
          "ok-only": "",
          "hide-header": "",
          "no-close-on-backdrop": "",
          "no-close-on-esc": "",
          size: "md",
          "content-class": "mx-4",
          "footer-class": "d-flex justify-content-center py-2"
        }, {
          "modal-footer": _withCtx(() => [
            _createVNode(AppButton, {
              class: "px-5 py-2",
              onClick: ($event: any) => (handleSubmit(onSubmit))
            }, {
              default: _withCtx(() => [
                _createTextVNode("\n          OK\n        ")
              ], undefined, true),
              _: 2
            }, 1032, ["onClick"])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _createTextVNode(),
              _createVNode(_component_BRow, { class: "mx-n2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_BCol, {
                    cols: "4",
                    class: "px-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ValidationProvider, {
                        name: "誕生年",
                        rules: "required",
                        vid: "birthDateYear",
                        modelValue: birthDateYear.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((birthDateYear).value = $event))
                      }, {
                        default: _withCtx((validationState) => [
                          _createVNode(FormSelectGroup, {
                            modelValue: birthDateYear.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((birthDateYear).value = $event)),
                            options: birthDateYearOptions.value,
                            firstOption: "年",
                            class: "mb-3 form-select",
                            "validation-state": validationState
                          }, null, 8, ["modelValue", "options", "validation-state"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ], undefined, true),
                    _: 1
                  }),
                  _createTextVNode(),
                  _createVNode(_component_BCol, {
                    cols: "4",
                    class: "px-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ValidationProvider, {
                        name: "誕生月",
                        rules: "required",
                        vid: "birthDateMonth",
                        modelValue: birthDateMonth.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((birthDateMonth).value = $event))
                      }, {
                        default: _withCtx((validationState) => [
                          _createVNode(FormSelectGroup, {
                            label: "",
                            modelValue: birthDateMonth.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((birthDateMonth).value = $event)),
                            options: birthDateMonthOptions.value,
                            firstOption: "月",
                            class: "mb-3 form-select",
                            "validation-state": validationState
                          }, null, 8, ["modelValue", "options", "validation-state"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ], undefined, true),
                    _: 1
                  }),
                  _createTextVNode(),
                  _createVNode(_component_BCol, {
                    cols: "4",
                    class: "px-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ValidationProvider, {
                        name: "誕生日",
                        rules: "required",
                        vid: "birthDateDay",
                        modelValue: birthDateDay.value,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((birthDateDay).value = $event))
                      }, {
                        default: _withCtx((validationState) => [
                          _createVNode(FormSelectGroup, {
                            modelValue: birthDateDay.value,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((birthDateDay).value = $event)),
                            options: birthDateDayOptions.value,
                            firstOption: "日",
                            class: "mb-3 form-select",
                            "validation-state": validationState,
                            ref_key: "birthDateDayElement",
                            ref: birthDateDayElement
                          }, null, 8, ["modelValue", "options", "validation-state"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              })
            ]),
            _createTextVNode()
          ], undefined, true),
          _: 2
        }, 1032, ["visible"])
      ]),
      _: 1
    }, 8, ["initial-values"]),
    _createTextVNode(),
    _createVNode(_component_BModal, {
      visible: __props.isShownIncorrectModal,
      centered: "",
      "ok-only": "",
      "hide-header": "",
      "no-close-on-backdrop": "",
      "no-close-on-esc": "",
      size: "md",
      "content-class": "mx-2",
      "footer-class": "d-flex justify-content-center py-2"
    }, {
      "modal-footer": _withCtx(() => [
        _createVNode(AppButton, {
          class: "px-5 py-2",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (emits('close')))
        }, {
          default: _withCtx(() => [
            _createTextVNode("\n        OK\n      ")
          ], undefined, true),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createTextVNode(),
          _createVNode(AppButtonOutline, {
            href: _unref(ExternalLink).CONTACT,
            class: "mt-1 mb-3",
            size: "small",
            block: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode("\n        お問い合わせフォーム\n      ")
            ], undefined, true),
            _: 1
          }, 8, ["href"])
        ]),
        _createTextVNode()
      ], undefined, true),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})